import { render } from "./AnswerLoopItem.vue?vue&type=template&id=dc9279fa&scoped=true"
import script from "./AnswerLoopItem.vue?vue&type=script&lang=js"
export * from "./AnswerLoopItem.vue?vue&type=script&lang=js"

import "./AnswerLoopItem.vue?vue&type=style&index=0&id=dc9279fa&scoped=true&lang=less"

import exportComponent from "D:\\Git仓库\\象新力官网\\html_xxldx_xxlx_xxlg\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc9279fa"]])

export default __exports__